import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';
import { AppUI } from '@seedlang/state';
import FormWrapper from 'components/authenticate/form_wrapper';
import Button from 'components/button/button';
import Text from 'components/text';
import { observer } from 'mobx-react';
import React from 'react';
import Link from 'components/link';
import Stack from 'components/layout/stack';

const StyledFormWrapper = styled(FormWrapper)`
  text-align: center;
  text-wrap: balance;
  height: 100%;
  display: flex;
  align-items: center;
`;

const TextLink = styled(Link)`
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
`;

const Note = styled.p`
  font-size: 14px;
  line-height: 18px;
  color: #222;
`;

export const AuthenticateExists = ({ accentColor, email }) => (
  <StyledFormWrapper>
    <Stack gap='md' alignItems='stretch'>
      <Text heading='3' center>
        Account Already Exists
      </Text>
      <p>
        An account with the email address{email && <strong> {email}</strong>} already exists.
      </p>
      <Note>
        Note: All Easy Languages membership sites and Seedlang share accounts. Please sign in with the same password you used there.
      </Note>
      <Stack gap='sm' alignItems='center'>
        <Button
          to='onboarding.sign_in'
          height='50px'
          width='100%'
          borderRadius='50px'
          background={accentColor || Theme.blue}
          backgroundOnHover={accentColor || Theme.blue}
          color='#FFF'
          scaleOnHover='1.05'
        >
          Sign In
        </Button>
        <TextLink to='onboarding.forgot_password'>
          Forgot Password?
        </TextLink>
        <TextLink to='onboarding.register'>
          Register for a New Account
        </TextLink>
      </Stack>
    </Stack>
  </StyledFormWrapper>
);

@observer
class AuthenticateExistsWrapper extends React.Component {
  render() {
    const email = new URLSearchParams(window.location.search).get('email');

    return (
      <AuthenticateExists
        accentColor={AppUI.site?.accentColor}
        email={email}
      />
    );
  }
}

export default AuthenticateExistsWrapper;